/* eslint-disable react/button-has-type */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  CheckFilled,
  CloseLarge,
  CloseSmall,
  ErrorFilled,
  ErrorOutlined,
  InformationStandard
} from '@carvana/purchase-icons';
import { NotificationContainer } from './toast.styles';

const Toast = props => {
  const { children, lifetime, message, position, type, className, retry } = props;

  const [opened, setOpened] = useState(true);

  const getIcon = () => {
    switch (type) {
      case 'error':
        return ErrorFilled;
      case 'warning':
        return ErrorOutlined;
      case 'success':
        return CheckFilled;
      case 'info':
        return InformationStandard;
      default:
        return InformationStandard;
    }
  };

  const TypeIcon = getIcon();

  useEffect(() => {
    if (lifetime === 0) return;

    setTimeout(() => {
      setOpened(false);
    }, lifetime);
  }, [message]);

  return (
    <NotificationContainer className={className}>
      {opened && (
        <>
          {children ? (
            <div
              className={`notification-container background-white ${position}`}
            >
              {children}
              <div className="notification-close close-small">
                <CloseSmall onClick={() => setOpened(false)} />
              </div>
            </div>
          ) : (
            <div className={`notification-container ${position}`}>
              <div className={`notification toast ${position} ${type}`}>
                <div className="notification-image">
                  <TypeIcon />
                </div>
                <div>
                  <p className="notification-message">{message}</p>
                  {type === 'error' && retry && (
                    <span className='retry-link' onClick={retry}>
                      Try again
                    </span>
                  )}
                </div>
                <div className="notification-close">
                  <CloseLarge onClick={() => setOpened(false)} />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </NotificationContainer>
  );
};

Toast.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  lifetime: PropTypes.number,
  message: PropTypes.string,
  position: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
};

Toast.defaultProps = {
  children: null,
  lifetime: 5000,
  message: null,
  position: 'top-right',
  type: 'info'
};

export default Toast;
